<template>
  <div>
    <AAlert :alert="alert" :errorOnly="true"></AAlert>
    <v-form ref="form" @submit.prevent="submit" lazy-validation>
      <v-row class="mt-0 ml-0 mr-0 pa-2 white" justify="start" align="start">
        <v-col class="ma-0 pl-2 pr-2 col-12 col-md-2 flex-shrink-1" v-if="hasBolPermission">
          <v-btn
            :color="session.active? 'error':'primary'"
            :loading="sessionLoading"
            @click="onSessionBtnClick"
          >
            <v-icon left>timer</v-icon>
            {{session.active? 'stop':'start'}} Session
          </v-btn>
        </v-col>
        <!-- <v-col class="ma-0 pl-2 pr-2 col-12 col-sm-6 col-md-3 col-lg-2">
          <v-btn color="primary">
            <v-icon left>list</v-icon>View Sessions
          </v-btn>
        </v-col>-->
        <v-col class="ma-0 pa-0 col-12 col-sm-6 col-md-3 col-lg-2 shrink">
          <v-select
            dense
            outlined
            :items="locations"
            label="Location*"
            v-model="location"
            :rules="locationRules"
            class="pa-2"
          ></v-select>
        </v-col>
        <v-col class="ma-0 pa-0 col-12 col-sm-6 col-md-3 col-lg-2" v-if="EnableCarInput">
          <v-text-field
            dense
            outlined
            :label="carLabel"
            v-model="car"
            :disabled="!EnableCarInput"
            :rules="carRules"
            class="pa-2"
          ></v-text-field>
        </v-col>
        <v-col class="ma-0 pa-0 col-12 col-sm-6 col-md-3 col-lg-2" v-if="needStatus">
          <v-select
            dense
            outlined
            clearable
            :items="states"
            label="Status*"
            v-model="state"
            :rules="stateRules"
            class="pa-2"
          ></v-select>
        </v-col>
        <v-col class="ma-0 pa-0 col-12 col-sm-6 col-md-3 col-lg-2" v-if="needMissingParts">
          <AMultiInput :input.sync="missingParts" :error="missingPartsError"></AMultiInput>
        </v-col>
        <v-col class="ma-0 pa-0 col-12 col-sm-6 col-md-3 col-lg-2">
          <v-text-field
            dense
            outlined
            clearable
            label="Cart ID*"
            :error="cartIdError"
            :type="'text'"
            v-model="cartId"
            :rules="cartIdRules"
            ref="refCartId"
            class="pa-2"
            background-color="yellow lighten-5"
            v-on:keyup.ctrl.32.exact="loadLastScannedValues()"
            hint="Press 'ctrl+space' to fetch current state"
          ></v-text-field>
        </v-col>
        <v-col class="ma-0 pl-2 pr-2 col-12 col-md-3 col-lg-1">
          <v-btn type="submit" color="success" :loading="loading" align="center" style="width:100%">
            <v-icon left>save</v-icon>Save
          </v-btn>
        </v-col>
        <!-- <v-col class="ma-0 pl-2 pr-2 col-12 col-md-3 col-lg-1">
          <v-btn
            color="primary"
            :disabled="loading"
            @click="loadLastScannedValues"
            style="width:100%"
          >
            <v-icon left>refresh</v-icon>fetch
          </v-btn>
        </v-col>-->
        <v-col class="ma-0 pl-2 pr-2 col-12 col-md-3 col-lg-1">
          <v-btn color="primary" :disabled="loading" @click="resetForm" text style="width:100%">
            <v-icon left>clear</v-icon>clear
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-layout class="mt-2">
      <v-flex>
        <CartsLog ref="refCartsLog"></CartsLog>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
import snackbarMixin from "../../mixins/snackbar";
import loadDropdownMixin from "../../mixins/loadDropdown";
import confirmDialogMixin from "../../mixins/ConfirmDialogMixin";
import CRUDFuncsMixin from "../../mixins/CRUDFuncs";
import CartsLog from "../../components/CartsLog";
import AAlert from "../../components/AAlert";
import AMultiInput from "../../components/AMultiInput";
import cartApi from "../../api/cart";
import axios from "../../api/axios";

function getValueForText(source, text) {
  for (let i = 0; i < source.length; i++) {
    const el = source[i];
    if (el.text == text) {
      return el.value;
    }
  }
  return;
}

export default {
  name: "cartscan",
  mixins: [
    snackbarMixin,
    loadDropdownMixin,
    confirmDialogMixin,
    CRUDFuncsMixin
  ],
  components: {
    CartsLog,
    AAlert,
    AMultiInput
  },
  data: () => ({
    model: "cartscanlog",
    locationRules: [v => !!v || "Location is required"],
    locations: [],
    location: undefined,
    stateRules: [v => !!v || "State is required"],
    states: [],
    state: undefined,
    cars: [],
    car: undefined,
    cartIdRules: [v => !!v || v.length > 0 || "Cart Id is required"],
    cartId: "",
    cartIdError: false,
    loading: false,
    alert: {},
    session: {
      active: false,
      startTime: undefined
    },
    sessionLoading: false,
    missingPartsOriginal: {},
    missingParts: []
  }),
  mounted() {
    this.loadDropdownItems2("locations", this.locations);
    this.loadDropdownItems2("states", this.states);
    this.$refs.refCartId.focus();
    this.checkUserSession();
  },
  computed: {
    EnableCarInput: function() {
      return this.location ? this.location.booleanField1 : false;
    },
    needStatus: function() {
      return this.location ? this.location.booleanField2 : false;
    },
    needMissingParts: function() {
      return this.needStatus && this.state ? this.state.booleanField1 : false;
    },
    carRules: function() {
      return this.EnableCarInput ? [v => !!v || "Car # is required"] : [];
    },
    carLabel: function() {
      return this.EnableCarInput ? "Car*" : "Car (Input Disabled)";
    },
    missingPartsError: function() {
      return (
        this.needMissingParts &&
        this.missingParts != undefined &&
        this.missingParts.length == 0
      );
    },
    missingPartsTransformed: function() {
      let v = {};
      if (this.needMissingParts && !this.missingPartsError) {
        this.missingParts.forEach(e => {
          v[e[0]] = e[1];
        });
      }
      return v;
    },
    hasBolPermission: function() {
      return this.$store.getters.hasPerm("PrintBol");
    }
  },
  methods: {
    async manageUserSession(path, activeOnSuccess, get) {
      try {
        this.sessionLoading = true;
        const res = get ? await axios.get(path) : await axios.put(path);
        if (res.data.ok) {
          this.session.active =
            activeOnSuccess == undefined ? res.data.d : activeOnSuccess;
        }
      } catch (error) {
        console.log(error);
        console.log(res.data);
      } finally {
        this.sessionLoading = false;
      }
    },
    async checkUserSession() {
      if (this.hasBolPermission)
        this.manageUserSession("/account/session-open-status", undefined, true);
    },
    onSessionBtnClick() {
      if (this.session.active)
        this.manageUserSession("/account/stop-session", false);
      else this.manageUserSession("/account/start-session", true);
    },
    resetForm() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.$refs.refCartId.focus();
      this.alert = {};
    },
    loadValueFromLog(cart) {
      if (!cart) {
        this.snackbar(
          "Something went wrong with reading the cart information from log :("
        );
        return;
      }
      this.location = getValueForText(this.locations, cart.locationName);
      this.state = getValueForText(this.states, cart.stateName);
      this.car = cart.car;
      this.missingParts.splice(0);
      if (cart.missingParts) {
        Object.keys(cart.missingParts).forEach((e, i) => {
          // this.$set()
          this.$set(this.missingParts, i, [e, cart.missingParts[e]]);
          // this.missingParts.push();
        });
      }
      // this.$set()
      this.snackbarSuccess("Latest values of the cart has been loaded");
    },
    resetExceptCartId() {
      let cartId = this.cartId;
      let self = this;
      this.resetForm();
      setTimeout(function() {
        self.cartId = cartId;
      }, 100);
    },
    loadLastScannedValues() {
      this.cartId = this.cartId.trim();
      this.cartIdError = false;
      if (!this.cartId || this.cartId.length == 0) {
        this.cartIdError = true;
        this.snackbar("Please fill in the Cart ID");
      } else {
        this.loading = true;
        axios
          .get("/carts?name=" + this.cartId.trim() + "&page=1&pageSize=1")
          .then(r => {
            this.loading = false;
            if (r.data && r.data.d) {
              if (r.data.d.error) {
                this.snackbar(r.data.d.error);
                console.log(err);
                return;
              }
              if (r.data.d.count == 0) {
                this.snackbarError(
                  "Cart ID '" + this.cartId + "' not found in the system"
                );
                this.resetExceptCartId();
                return;
              }
              this.loadValueFromLog(r.data.d.items[0]);
              return;
            }
          })
          .catch(err => {
            this.loading = false;
            this.snackbar("Something went wrong :(");
            console.log(err);
          });
      }
      // axios.get("axios")
    },
    submit(event, createIfNotFound = false) {
      if (this.formValidate()) {
        this.loading = true;
        this.alert = {};
        cartApi.scan(this.params(createIfNotFound), data => {
          this.loading = false;
          this.alert = data;
          if (data.ok) {
            this.$refs.form.resetValidation();
            // clear cart ID to avoid accidental duplicate scan
            this.clearAfterScan();
            this.$refs.refCartsLog.refresh();
          } else {
            if (data.d && data.d.CartNotFound) {
              this.confirmDialog(
                "Cart with ID '" +
                  this.cartId +
                  "' is not found in system. Do you wish to add this now permenantly?",
                () => this.submit(null, true),
                () => this.snackbar("Cart was not saved")
              );
            }
          }
          this.$refs.refCartId.focus();
        });
      } else {
        this.snackbarWarn("Please fill the highlighted fields");
      }
    },
    formValidate() {
      let result = this.$refs.form.validate();
      // this.missingPartsError =
      //   this.needMissingParts && this.missingParts.length == 0;
      return result && !this.missingPartsError;
    },
    clearAfterScan() {
      this.cartId = "";
      this.missingParts = [];
    },
    params(createIfNotFound) {
      return {
        cartSpecialId: this.cartId.trim(),
        locationId: this.location.id,
        stateId: this.needStatus ? this.state.id : 0,
        car: this.EnableCarInput ? this.car : "",
        missingParts: this.missingPartsTransformed,
        createIfNotFound: createIfNotFound
      };
    }
  },
  watch: {
    location: function() {
      if (!this.EnableCarInput) {
        this.car = undefined;
      }
    }
  }
};
</script>


<style>
</style>

